<script setup>
import {ref, defineEmits, defineProps, onMounted} from 'vue';
import {required, validSelection} from '@ohrm/core/util/validation/rules';
import EmployeeAutocomplete from '@/core/components/inputs/EmployeeAutocomplete';
import MultiChips from '@ohrm/oxd/core/components/Input/MultiSelect/MultiSelectChips.vue';

const props = defineProps({
  operator: {
    type: Object,
    required: false,
    default: () => null,
  },
  valueX: {
    type: Object,
    required: false,
    default: () => null,
  },
  valueY: {
    type: Object,
    required: false,
    default: () => null,
  },
  criterion: {
    type: Object,
    required: false,
    default: () => null,
  },
});
const emit = defineEmits(['update:valueX', 'update:operator']);

const rules = [required, validSelection];
const selectedEmployees = ref([]);

const addEmployee = event => {
  if (
    !selectedEmployees.value.find(e => e?.id === event?.id) &&
    typeof event === 'object'
  ) {
    selectedEmployees.value.push(event);
    emit('update:valueX', selectedEmployees.value);
  }
};

const removeEmployee = id => {
  const index = selectedEmployees.value.findIndex(e => e.id === id);
  selectedEmployees.value.splice(index, 1);
  emit('update:valueX', selectedEmployees.value);
};

onMounted(() => {
  emit('update:operator', {id: 'eq', label: 'Equal'});
  if (props.valueX) {
    selectedEmployees.value = props.valueX;
  }
});
</script>

<template>
  <oxd-grid-item>
    <employee-autocomplete
      v-bind="$attrs"
      :params="{
        includeEmployees: 'currentAndPast',
      }"
      :rules="rules"
      :model-value="valueX"
      @update:modelValue="addEmployee"
    ></employee-autocomplete>
  </oxd-grid-item>
  <oxd-grid-item class="flex items-center --span-column-2">
    <MultiChips
      :selected="selectedEmployees"
      @chipRemoved="emp => removeEmployee(emp.id)"
    />
  </oxd-grid-item>
</template>

<style lang="scss" scoped>
::v-deep(.oxd-input-group__label-wrapper) {
  display: none;
}
</style>
